const PdfViewer = ({ url }) => {
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <object
        aria-label="pdf-viwer"
        data={`${url}`}
        type="application/pdf"
        width="100%"
        height="100%"
      ></object>
    </div>
  );
};

export default PdfViewer;
